export enum AccessType {
  ACTION = 'ACTION',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  SEARCH = 'SEARCH',
  UPDATE = 'UPDATE'
}
